<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="3" class="py-2">
                <span>Banners</span>
              </b-col>
              <b-col cols="12" md="3" class="py-2">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  router-link
                  to="/Banners/Add"
                  >Add New Banner</b-button
                >
              </b-col>
            </b-row>
          </template>
          <b-row>
            <b-col v-for="(item, i) in banners" :key="i" cols="12" md="4">
              <b-card
                :img-src="baseURL + '/r/' + item.image"
                img-top
                style="max-width: 30rem"
                :title="item.heading"
              >
                <b-card-text>
                  {{ item.description }}
                </b-card-text>

                <template slot="footer">
                  <b-row class="justify-content-center">
                    <div class="px-2">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        :to="'/Banners/Edit/' + item.id"
                        >Edit</b-button
                      >
                    </div>
                    <div class="px-2">
                      <b-button
                        variant="danger"
                        size="sm"
                        @click.prevent="confirmRemoveBanner(item)"
                        >Remove Banner</b-button
                      >
                    </div>
                  </b-row>
                </template>
              </b-card>
            </b-col>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      banners: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/banner/all",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.banners = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    confirmRemoveBanner(item) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to Remove this Banner.", {
          title: "Please Confirm",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          cancelVariant: "primary",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.removeBanner(item);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    removeBanner(item) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/banner/delete",
        data: {
          id: item.id,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: "Banner Deleted Successfully",
              text: "",
              type: "success",
            });
            this.getData();
          } else {
            this.msg = response.data.msg;
            var vm = this;
            this.$notify({
              group: "appNotification",
              title: vm.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.ServerError = true;
        });
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
